export var QuestionType;
(function (QuestionType) {
    QuestionType["WELCOME"] = "welcome";
    QuestionType["MULTIPLE_CHOICE"] = "multiple_choice";
    QuestionType["PICTURE_CHOICE"] = "picture_choice";
    QuestionType["YES_NO"] = "yes_no";
    QuestionType["DROPDOWN"] = "dropdown";
    QuestionType["SHORT_TEXT"] = "short_text";
    QuestionType["LONG_TEXT"] = "long_text";
    QuestionType["LEGAL"] = "legal";
    QuestionType["RATING"] = "rating";
    QuestionType["UPLOAD_MEDIA"] = "upload_media";
    QuestionType["END_SCREEN"] = "end_screen";
})(QuestionType || (QuestionType = {}));
export var LayoutType;
(function (LayoutType) {
    LayoutType["DEFAULT"] = "DEFAULT";
    LayoutType["TOP_SPLIT"] = "TOP_SPLIT";
    LayoutType["LEFT_SPLIT"] = "LEFT_SPLIT";
    LayoutType["RIGHT_SPLIT"] = "RIGHT_SPLIT";
})(LayoutType || (LayoutType = {}));
export var FormPresentationType;
(function (FormPresentationType) {
    FormPresentationType["SINGLE_PAGE"] = "SINGLE_PAGE";
    FormPresentationType["MULTI_PAGE"] = "MULTI_PAGE";
})(FormPresentationType || (FormPresentationType = {}));
export var FormActionType;
(function (FormActionType) {
    FormActionType["CREATE_CLIENT"] = "CREATE_CLIENT";
    FormActionType["AUTO_ONBOARD"] = "AUTO_ONBOARD";
    FormActionType["SEND_PDF_HOOK"] = "SEND_PDF_HOOK";
})(FormActionType || (FormActionType = {}));
// Form template category enum
export var FormTemplateCategory;
(function (FormTemplateCategory) {
})(FormTemplateCategory || (FormTemplateCategory = {}));
